import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Table } from "../../../../../components/ui/Table";
import { FormatInt } from "../../../../../utils/FormatData";
const TableWebservice = (props) => {
  const { data } = props;

  const COLUMNS = useMemo(() => {
    if (!data.length) {
      return [];
    }

    return [
      {
        Header: "Fecha",
        accessor: "dt_report",
      },
      {
        Header: "Partner",
        accessor: "vc_partner",
      },
      {
        Header: "Recibidos",
        accessor: "i_received",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_received);
          return FormatInt(value);
        },
      },
      {
        Header: "Invalidos",
        accessor: "i_invalid",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_invalid);
          return FormatInt(value);
        },
      },
      {
        Header: "Validos",
        accessor: "i_valids",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_valids);
          return FormatInt(value);
        },
      },
      {
        Header: "Enviados",
        accessor: "i_sent",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_sent);
          return FormatInt(value);
        },
      },
      {
        Header: "Entregados",
        accessor: "i_delivered",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_delivered);
          return FormatInt(value);
        },
      },
      {
        Header: "Errores",
        accessor: "i_errors",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_errors);
          return FormatInt(value);
        },
      },
      {
        Header: "Líneas no móviles",
        accessor: "i_nomovil",
        Cell: (rowData) => {
          let value = Number(rowData.row.original.i_nomovil);
          return FormatInt(value);
        },
      },
    ];
  }, [data]);
  return (
    <Table
      data={data}
      columns={COLUMNS}
      config={{
        search: true,
        footer: true,
        printfooter: true,
        pageSize: 10,
        perPage: 10,
        export: true,
      }}
    />
  );
};

TableWebservice.propTypes = {
  data: PropTypes.array,
};

export default TableWebservice;
